import { render, staticRenderFns } from "./TabRouteView.vue?vue&type=template&id=70578b94&scoped=true&"
import script from "./TabRouteView.vue?vue&type=script&lang=js&"
export * from "./TabRouteView.vue?vue&type=script&lang=js&"
import style0 from "./TabRouteView.vue?vue&type=style&index=0&id=70578b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70578b94",
  null
  
)

export default component.exports